import styled from 'styled-components';
import { body5Styles } from '../../typography/style';
export var InputGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__InputGroup",
  componentId: "wc8v6q-0"
})(["width:100%;position:relative;margin:15px 0 0 0;"]);
export var Underline = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__Underline",
  componentId: "wc8v6q-1"
})(["position:relative;display:block;width:100%;", ""], p => (!p.readOnly || p.interactableReadOnly) && "\n        &:before {\n            content: '';\n            height: 2px;\n            width: ".concat(p.isActive ? '100%' : '0', ";\n            bottom: 0px;\n            position: absolute;\n            background: ").concat(p.theme.colors.primary500, ";\n            transition: 130ms linear all;\n            left: 50%;\n            transform: translateX(-50%);\n        }\n    "));
export var Description = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Description",
  componentId: "wc8v6q-2"
})(["", ";", ""], body5Styles, p => "color: ".concat(p.theme.colors.gray600, ";"));